import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Form, FormControl } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { STORE_ACCEPTANCES } from "../../../constants";
import { AcceptancesStore, NewAcceptancePosition } from "../../../stores";
import { DocumentPageHeader } from "../../../components/DocumentPageHeader";
import { wrapInput } from "../../../common/FormChangeWrapper";
import { formatDate, formatMoney } from "../../../common/Formatting";
import { NotificationLevel } from "../../../stores/NotificationStore";
import { ShortCustomerOrderModal } from "../SharedComponents/ShortCustomerOrderModal";
registerLocale('ru', ru)

interface IProps {
    history: any,
    [STORE_ACCEPTANCES]: AcceptancesStore
}

interface IState {
    currentPage: number,
    filterFormIsOpened: boolean,
    dateFrom?: Date,
    dateTo?: Date,
    newAcceptanceModalIsOpened: boolean,
    acceptancePositions: NewAcceptancePosition[],
    comment: string,
    formUniqueKey: number,
    orderDetailsModalIsOpened: boolean,
    selectedOrderGuid: string
}


type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_ACCEPTANCES)
@observer
export class CreateAcceptancePage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page,
            filterFormIsOpened: false,
            newAcceptanceModalIsOpened: false,
            acceptancePositions: [],
            comment: "",
            formUniqueKey: new Date().getTime(),
            orderDetailsModalIsOpened: false,
            selectedOrderGuid: ""
        };
    }

    acceptancesStore = (this.props as any)[STORE_ACCEPTANCES] as AcceptancesStore;

    loadData = () => {
        this.acceptancesStore.loadWaitingAcceptances();
    }

    componentDidMount() {
        this.loadData();
    }

    private saveAcceptance = () => {
        const positions = this.state.acceptancePositions.filter(w => w.acceptCount > 0);
        if (!positions.any()) {
            this.acceptancesStore._rootStore.notificationStore.addNotification("Приемка пустая", NotificationLevel.error);
            return;
        }

        if (window.confirm("Вы сохраняете приемку. Продолжить?"))
            this.acceptancesStore.createAcceptance(this.state.formUniqueKey, positions, this.state.comment, () => {
                this.props.history.push("/deliverypoint/acceptances");
            });
    }

    private onFormChange = (fieldName: string, value: string) => {
        (this as any).setState({
            [fieldName]: value
        });
    }

    private onChangeCount = (value: string, positionId: number) => {
        let newCount = parseInt(value);
        if (newCount == undefined)
            return;
        newCount = newCount < 0 ? 0 : newCount;

        const positions = this.acceptancesStore.waitingDemands.filter(w => w.id == positionId);
        const position = positions.length == 1 ? positions[0] : null;

        if (position == null)
            return;

        if (position.count - position.acceptedCount <= newCount)
            newCount = position.count - position.acceptedCount;

        const oldAcceptancePositions = this.state.acceptancePositions;
        let acception = oldAcceptancePositions.filter(w => w.positionId == positionId)[0];
        if (acception != undefined) {
            acception.acceptCount = newCount;
        }
        else {
            acception = { acceptCount: newCount, positionId: positionId };
        }
        this.setState({
            acceptancePositions: [...oldAcceptancePositions.filter(w => w.positionId != positionId), acception]
        })
    }

    render() {
        return [
            <DocumentPageHeader
                saveBtnTitle="Сохранить"
                header="Приемка товара"
                save={this.saveAcceptance}
                close={() => {
                    this.props.history.push("/deliverypoint/acceptances");
                }}
                isDraft={false}
                key="1">
            </DocumentPageHeader>,
            <Row key="2">
                <Col sm={12}>
                    <Form>
                        <Row>
                            <Col sm="4">
                                <Form.Group as={Row} controlId="formComment">
                                    <Form.Label column sm="4">Комментарий менеджера</Form.Label>
                                    <Col sm="8">
                                        <textarea className="form-control"
                                            name="comment"
                                            value={this.state.comment}
                                            onChange={wrapInput(this.onFormChange)}></textarea>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Table bordered striped className="table-xxs">
                            <thead>
                                <tr>
                                    <th className="text-center">Номер заказа</th>
                                    <th className="text-center" style={{ width: "110px" }}>Дата создания</th>
                                    <th className="text-center" style={{ width: "250px" }}>Клиент</th>
                                    <th className="text-center">Статус</th>
                                    <th className="text-center" style={{ width: "150px" }}>Бренд</th>
                                    <th className="text-center" style={{ width: "110px" }}>Артикул</th>
                                    <th>Описание</th>
                                    <th className="text-center">Поставщик</th>
                                    <th className="text-center">Цена</th>
                                    <th className="text-center">Количество</th>
                                    <th className="text-center">Уже принято</th>
                                    <th className="text-center" style={{ width: "50px" }}>Поступило</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.acceptancesStore.waitingDemands.map((w, index) => {
                                    const accepted = this.state.acceptancePositions.filter(ww => ww.positionId == w.id)[0];
                                    const acceptedCount = accepted != undefined ? accepted.acceptCount : 0;
                                    return <tr key={index}>
                                        <td className="text-center">
                                            <a href="javascript:void(0)" onClick={() => {
                                                this.setState({
                                                    orderDetailsModalIsOpened: true,
                                                    selectedOrderGuid: w.orderGuid
                                                });
                                            }} style={{ cursor: "pointer" }}>{w.orderNumber}</a></td>
                                        <td className="text-center">{formatDate(w.dateCreated)}</td>
                                        <td className="text-center">{w.customerName}</td>
                                        <td className="text-center">{w.statusName}</td>
                                        <td className="text-center">{w.brand}</td>
                                        <td className="text-center">{w.article}</td>
                                        <td>{w.description}</td>
                                        <td className="text-center">{w.supplierName}</td>
                                        <td className="text-center">{formatMoney(w.costSale)}</td>
                                        <td className="text-center">{w.count}</td>
                                        <td className="text-center">{w.acceptedCount}</td>
                                        <td className="text-center">
                                            <FormControl size="sm" type="number"
                                                value={acceptedCount.toString()}
                                                onChange={wrapInput((fieldName: string, value: string) => {
                                                    this.onChangeCount(value, w.id);
                                                })} />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </Form>
                </Col>
            </Row>,
            <ShortCustomerOrderModal
                key={4}
                isOpened={this.state.orderDetailsModalIsOpened}
                onClose={() => {
                    this.setState({
                        orderDetailsModalIsOpened: false
                    })
                }}
                orderGuid={this.state.selectedOrderGuid}
            />
        ]
    }

}